var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28204 11.254C1.25805 10.9731 1.24735 10.6884 1.25056 10.4005C1.30396 5.59649 5.19574 1.75 10 1.75C14.8346 1.75 18.7534 5.67091 18.75 10.5063C18.7466 15.3222 14.7992 19.259 9.98332 19.25C5.55591 19.2417 1.65985 15.6801 1.28204 11.254Z",
    fill: "#F1B04F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15017 11.0924C3.13133 10.8717 3.12292 10.648 3.12544 10.4218C3.1674 6.64724 6.22522 3.625 10 3.625C13.7986 3.625 16.8777 6.70571 16.875 10.5049C16.8724 14.2889 13.7708 17.382 9.98689 17.375C6.50822 17.3685 3.44702 14.5701 3.15017 11.0924Z",
    fill: "#FFFDDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8769 6.57023L11.6784 7.69638C11.8166 7.89049 12.0198 8.03286 12.2539 8.09955L13.6122 8.48664C14.3283 8.69068 14.6091 9.52412 14.1542 10.0951L13.2912 11.1782C13.1424 11.3649 13.0649 11.5952 13.0714 11.8306L13.1094 13.196C13.1294 13.9158 12.3942 14.4308 11.6906 14.19L10.3557 13.7332C10.1256 13.6545 9.87445 13.6545 9.64434 13.7332L8.30945 14.19C7.60577 14.4308 6.87057 13.9157 6.89062 13.196L6.92861 11.8306C6.93514 11.5952 6.85752 11.3649 6.70881 11.1782L5.84581 10.0951C5.3909 9.52412 5.6717 8.69068 6.38777 8.48664L7.74612 8.09955C7.98025 8.03281 8.18343 7.89049 8.32159 7.69638L9.12313 6.57023C9.54561 5.97659 10.4543 5.97659 10.8769 6.57023Z",
    fill: "#FAE449"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScore);
export default __webpack_public_path__ + "static/media/score.340790c63f5834786365102dc22cd182.svg";
export { ForwardRef as ReactComponent };